import apiClient from '../connections/api'

export const getMachineByEquid = async (equid) => {
    const response = await apiClient.get(`/machines/equid/${equid}`)
    return response
}

export const agregarTipoMaquina = async (tipo) => {
    const response = await apiClient.post('/type-machines', { tipo: tipo })
    return response.data
}

export const agregarMarcaMaquina = async (marca) => {
    const response = await apiClient.post('/marks-machine', { marca: marca })
    return response.data
}

export const agregarModeloMaquina = async (marcaId, modelo) => {
    const response = await apiClient.post('/model-machines', { marca: marcaId, modelo: modelo })
    return response.data
}

export const obtenerTipoMaquinas = async () => {
    const response = await apiClient.get('/type-machines')
    return response.data
}

export const obtenerMarcaMaquinas = async () => {
    const response = await apiClient.get('/marks-machine')
    return response.data
}

export const obtenerModeloMaquinas = async () => {
    const response = await apiClient.get('/model-machines')
    return response.data
}

export const createMachine = async (machine) => {
    const response = await apiClient.post('/machines', machine)
    return response.data
}

export const editMachine = async (machine) => {
    const response = await apiClient.put(`/machines/${machine._id}`, machine)
    return response.data
}

export const syncMachinesBySiteId = async (siteId) => {
    const response = await apiClient.post(`/machines/sync/${siteId}`)
    return response.data
}

export const assignTypeToMachineOfProject = async (machineOfProjectId, typeId) => {
    const response = await apiClient.patch(`/machines/template/${machineOfProjectId}/assign-type`, { typeId })
    return response.data
}

export const deleteMachine = async (id) => {
    const response = await apiClient.delete(`/machines/${id}`)
    return response.data
}

export const getMachinesByModel = async (model) => {
    const response = await apiClient.get(`/machines/by-model?model=${model}`)
    return response.data
}

export const getModelandSite = async (model, idobra) => {
    console.log('Router de sites y model:', model, 'and idobra:', idobra)
    const response = await apiClient.get('/machines/byModelandSite', { params: { model, idobra } })
    return response.data
}

export const getMachinesBySite = async (siteId) => {
    const response = await apiClient.get('/machines/by-site', { params: { siteId } })
    return response.data
}

export const createMachineOfProject = async (machineOfProject) => {
    const response = await apiClient.post('/machines/createMachineOfProject', machineOfProject)
    return response.data
}

export const migrateMachinesToSite = async (fromIdObra, toIdObra, toIdObraAlfa) => {
    const response = await apiClient.post('/machines/migrate-to-site', { fromIdObra, toIdObra, toIdObraAlfa })
    return response.data
}
